import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const GuestOnly = ({ component: Component, ...props }) => {
  const { loggedInUser } = useAuth();

  if (!loggedInUser) return <Component {...props} />;

  return <Navigate to="/app" />;
};

export default GuestOnly;
